import type { ChipProps } from '@mui/material';

export const ADMIN_ROWS_PER_PAGE = 5;
export const ADMIN_USERS_ROWS_PER_PAGE = 10;
export const ADMIN_SEARCH_DEBOUNCE_MS = 500;

export const ADMIN_JOB_OPENING_LABEL_ORDER: string[] = [
  'Job Description',
  'Job Posting',
  'Short Listing',
  'Interview',
  'Decision Making',
  'Closed',
];

export const ADMIN_SESSION_LABELS: string[] = ['Completed', 'Not Completed'];

export const ADMIN_USER_TYPE_COLOR_MAP: Record<string, ChipProps['color']> = {
  Admin: 'primary',
  Participant: 'default',
  Employee: 'success',
};

export const ADMIN_STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  Active: 'success',
  Pending: 'warning',
  Inactive: 'default',
};

export const ADMIN_TIME_RANGES = ['Week', 'Month', '6 Months'] as const;
export type AdminTimeRange = (typeof ADMIN_TIME_RANGES)[number];
